export default "__VITE_ASSET__bd0f0744__"